"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getNestedPropertiesAsStrings = _interopRequireDefault(require("redux-less/utils/getNestedPropertiesAsStrings"));

var _isPropertyChanged = _interopRequireDefault(require("./isPropertyChanged"));

var _immutable = require("immutable");

var _default = function _default(_ref) {
  var property = _ref.property,
      currentValue = _ref.currentValue,
      nextValue = _ref.nextValue;
  var nestedPropertiesAsStrings = (0, _getNestedPropertiesAsStrings.default)(property);
  var changes = 0;
  nestedPropertiesAsStrings.forEach(function (prop) {
    var path = prop.split("/");
    path.shift();

    if (typeof currentValue.getIn === "function" && typeof nextValue.getIn === "function" && (0, _isPropertyChanged.default)(currentValue.getIn(path), nextValue.getIn(path))) {
      changes += 1;
    } else {
      var currentValueImmutable = (0, _immutable.fromJS)(currentValue);
      var nextValueImmutable = (0, _immutable.fromJS)(nextValue);

      if ((0, _isPropertyChanged.default)(currentValueImmutable.getIn(path), nextValueImmutable.getIn(path))) {
        changes += 1;
      }
    }
  });
  return changes;
};

exports.default = _default;
module.exports = exports.default;